import {MobiusClient} from "@mobiusjs/site-client";
import Theme from "./theme";

const state = window.currentState,
    auth = state.auth,
    routes = state.routes,
    isLocal = routes.local,
    project = routes.project

const client = MobiusClient(__dirname, Theme)
let config = require('../config' + (isLocal ? ".local" : "")).default

if (auth.current) {
    let currentProject = auth.current.projects.filter(t => t.name === project)
    if (currentProject && currentProject.length) config.project = currentProject[0]
}

//if (project) config = require('../configs/' + project + (isLocal ? ".local" : "")).default
config.theme = require('./config' + (isLocal ? ".local" : "")).default
client.setConfig(config);

client.setPlugins({
    book: require("@mobiusjs/touryup-book-site-client").default
})

client.run()

